import React, { useState } from 'react';
import {
    Box,
    Button,
    MenuItem,
    Stack,
    Typography,
    Menu,
    styled,
    InputBase,
    Radio,
    FormControlLabel,
    Select,
    FormControl,
    Grid,
    Card,
    CardContent,
    ListItemText,
    List,
    ListItemAvatar,
    Avatar,
    ListItem,
    Pagination,
    PaginationItem,
    ListItemButton,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { Link } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MainCard from '../MainCard';
import SearchIcon from '@mui/icons-material/Search';
import { KeyboardArrowDownOutlined } from '@mui/icons-material';
import NorthOutlinedIcon from '@mui/icons-material/NorthOutlined';
import SouthOutlinedIcon from '@mui/icons-material/SouthOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import { getImages } from '../const';
import Modals from '../Modals';
import InvestmentsProcessModal from './InvestmentsProcessModal';

const SolutionInvestmentSummary = () => {
    const theme = useTheme();
    const Search = styled('div')(({ theme }) => ({
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: '#DBEBF8',
        '&:hover': {
            backgroundColor: '#DBEBF8',
        },
        marginLeft: 0,
        marginBottom: 0,
        width: '300px',
        [theme.breakpoints.down('md')]: {
            width: 'calc(100% - 180px)',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    }));
    const SearchIconWrapper = styled('div')(({ theme }) => ({
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        right: '0',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }));

    const StyledInputBase = styled(InputBase)(({ theme }) => ({
        color: '#106EED',
        width: '100%',
        '& .MuiInputBase-input': {
            padding: theme.spacing(1.6, 0, 1.9, 1.5),
            paddingRight: `calc(1em + ${theme.spacing(4)})`,
            transition: theme.transitions.create('width'),
            width: '100%',
            fontSize: '12px',
            fontWeight: '500'
        },
    }));
    // Sort and Filter
    const [openSort, setOpenSort] = useState(false);
    const [selectedSortOption, setSelectedSortOption] = useState('');

    const [openFilter, setOpenFilter] = useState(false);
    const [anchorElSort, setAnchorElSort] = useState(null);
    const [anchorElFilter, setAnchorElFilter] = useState(null);
    const handleClickSort = (event) => {
        setAnchorElSort(event.currentTarget);
        setOpenSort(!openSort);
    };
    const handleCloseSort = (event) => {
        setAnchorElSort(null);
        setOpenSort(false);
        setSelectedSortOption(event.target.value);
    };
    const handleClickFilter = (event) => {
        setAnchorElFilter(event.currentTarget);
        setOpenFilter(!openFilter);
    };
    const handleCloseFilter = () => {
        setAnchorElFilter(null);
        setOpenFilter(false);
    };
    // Select 
    const [designation, setDesignation] = useState('');
    const handleChange = (event) => {
        setDesignation(event.target.value);
    };
    // Pagination
    const [page, setPage] = useState(1);
    const handlePaginationChange = (event, value) => {
        setPage(value);
    };
    // Commitment Modal
    const [openCommitment, setOpenCommitment] = useState(false);
    const [investTypeName, setInvestTypeName] = useState('');
    const handleCommitment = (investType) => {
        setOpenCommitment(true)
        setInvestTypeName(investType)
    }
    const closeCommitment = () => {
        setOpenCommitment(false)
    }
    return (
        <>
            <Box>
                <Typography
                    sx={{
                        fontSize: "1.4rem",
                        fontWeight: "700",
                        color: 'secondary.main',
                        display: 'flex',
                        [theme.breakpoints.down('md')]: {
                            fontSize: '1.1rem',
                        },
                    }} variant="h4"
                    noWrap component="div">
                    <Link to="/my-solutions"
                        style={{
                            color: '#2A589C',
                            textDecoration: "none"
                        }}
                    >
                        <KeyboardBackspaceIcon
                            sx={{
                                verticalAlign: "-12px",
                                fontSize: '40px',
                                [theme.breakpoints.down('md')]: {
                                    fontSize: '35px',
                                    verticalAlign: "-12px",
                                },
                            }}
                        />
                        TRUSTDOCK Digital ID
                    </Link>
                </Typography>
            </Box>
            <Box
                sx={{
                    mt: 2
                }}
            >
                <Typography
                    underline="hover"
                    key="2"
                    color="inherit"
                    sx={{
                        color: '#2A589C',
                        textDecoration: "none",
                        fontSize: "1.4rem",
                        fontWeight: "700",
                        color: '#073985',
                        [theme.breakpoints.down('md')]: {
                            fontSize: '1.1rem',
                        },
                    }}
                >Investment Summary</Typography>
                <Grid container mt={1} columnSpacing={2}>
                    <Grid item xs={12} md={6} lg={3}>
                        <Card
                            sx={{
                                boxShadow: 'none',
                                mb: 2
                            }}
                        >
                            <CardContent
                                style={{
                                    paddingTop: "25px"
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: '500',
                                        color: 'ltheme.main',
                                    }}
                                >
                                    Raised Amount
                                    <InfoOutlinedIcon
                                        sx={{
                                            verticalAlign: 'middle',
                                            ml: 0.5,
                                            fontSize: '17px'
                                        }}
                                    /></Typography>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontSize: '2.4rem',
                                        fontWeight: '700',
                                        lineHeight: '2.7rem',
                                        color: 'lightSecondary.main',
                                        mb: 0.5,
                                        mt: 0.5,
                                    }}
                                >$600k</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Card
                            sx={{
                                boxShadow: 'none',
                                mb: 2
                            }}
                        >
                            <CardContent
                                style={{
                                    paddingTop: "25px"
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: '500',
                                        color: 'ltheme.main',
                                    }}
                                >
                                    Total Investments
                                    <InfoOutlinedIcon
                                        sx={{
                                            verticalAlign: 'middle',
                                            ml: 0.5,
                                            fontSize: '17px'
                                        }}
                                    /></Typography>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontSize: '2.4rem',
                                        fontWeight: '700',
                                        lineHeight: '2.7rem',
                                        color: 'lightSecondary.main',
                                        mb: 0.5,
                                        mt: 0.5,
                                    }}
                                >$950k
                                    <span
                                        style={{
                                            fontSize: '1rem',
                                            lineHeight: '1rem',
                                            color: '#106EED',
                                            marginLeft: '10px',
                                            fontWeight: '600'
                                        }}
                                    >in 2 Solutions</span></Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Card
                            sx={{
                                boxShadow: 'none',
                                mb: 2
                            }}
                        >
                            <CardContent
                                style={{
                                    paddingTop: "25px"
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: '500',
                                        color: 'ltheme.main',
                                    }}
                                >
                                    Total Commitment
                                    <InfoOutlinedIcon
                                        sx={{
                                            verticalAlign: 'middle',
                                            ml: 0.5,
                                            fontSize: '17px'
                                        }}
                                    /></Typography>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontSize: '2.4rem',
                                        fontWeight: '700',
                                        lineHeight: '2.7rem',
                                        color: 'lightSecondary.main',
                                        mb: 0.5,
                                        mt: 0.5,
                                    }}
                                >$620k
                                    <span
                                        style={{
                                            fontSize: '1rem',
                                            lineHeight: '1rem',
                                            color: '#106EED',
                                            marginLeft: '10px',
                                            fontWeight: '600'
                                        }}
                                    >in 2 Solutions</span></Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Card
                            sx={{
                                boxShadow: 'none',
                                mb: 2
                            }}
                        >
                            <CardContent
                                style={{
                                    paddingTop: "25px"
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: '500',
                                        color: 'ltheme.main',
                                    }}
                                >
                                    Overall Return
                                    <InfoOutlinedIcon
                                        sx={{
                                            verticalAlign: 'middle',
                                            ml: 0.5,
                                            fontSize: '17px'
                                        }}
                                    /></Typography>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontSize: '2.4rem',
                                        fontWeight: '700',
                                        lineHeight: '2.7rem',
                                        color: 'lightSecondary.main',
                                        mb: 0.5,
                                        mt: 0.5,
                                    }}
                                >$13.26
                                    <span
                                        style={{
                                            fontSize: '1rem',
                                            color: '#DD7C7C',
                                            lineHeight: '1rem',
                                            fontWeight: '600'
                                        }}
                                    >
                                        <ArrowDropDownIcon
                                            sx={{
                                                verticalAlign: 'middle'
                                            }}
                                        /> 1.3%
                                    </span>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            <Grid container mt={1} mb={3} columnSpacing={2}>
                <Grid item xs={12} md={6} lg={6} 
                    sx={{
                        mb:2
                    }}
                >
                    <MainCard content={false}
                        sx={{
                            backgroundColor: "#ECF6FF",
                            border: "none",
                            padding: "20px",
                            boxShadow: "none",
                            borderRadius: "10px"
                        }}
                    >

                        <Typography variant='h6'
                            sx={{
                                color: 'secondary.main',
                                fontSize: "1.1rem",
                                fontWeight: "700",
                                mb: 1
                            }}
                        >
                            Investments
                        </Typography>
                        <Stack
                            direction="row"
                            sx={{
                                justifyItems: 'center',
                                justifyContent: 'space-between',
                                mt: 0,
                                [theme.breakpoints.down('md')]: {
                                    flexWrap: 'wrap'
                                }
                            }}
                        >
                            <Search
                                sx={{
                                    width: 'calc(100% - 150px)',
                                    backgroundColor: '#DBEBF8',
                                    mb: 2.5,
                                    mr: 2,
                                    [theme.breakpoints.down('md')]: {
                                        width: 'calc(100% - 220px)',
                                    },
                                    [theme.breakpoints.down('sm')]: {
                                        mr: 0,
                                        width: '100%',
                                    }
                                }}
                            >
                                <SearchIconWrapper>
                                    <SearchIcon sx={{ color: "lightSecondary.main" }} />
                                </SearchIconWrapper>
                                <StyledInputBase
                                    id="searchBox"
                                    placeholder="Search investment"
                                    inputProps={{ 'aria-label': 'search' }}
                                />
                            </Search>
                            <Box
                                sx={{
                                    mr: 2,
                                    mb: 2.5,
                                    [theme.breakpoints.down('sm')]: {
                                        width: "calc(50% - 0.5rem)",
                                        mr: '0.5rem',
                                    }
                                }}
                            >
                                <Button
                                    id="basic-button"
                                    aria-controls={openSort ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openSort ? 'true' : undefined}
                                    onClick={handleClickSort}
                                    sx={{
                                        background: "#fff",
                                        fontSize: "0.9rem",
                                        color: "lightSecondary.main",
                                        textTransform: "inherit",
                                        fontWeight: "600",
                                        p: "10px 20px",
                                        '&:hover': {
                                            background: "#fff",
                                        },
                                        [theme.breakpoints.down('md')]: {
                                            width: "100%"
                                        }
                                    }}
                                >
                                    Sort
                                    <KeyboardArrowDownOutlined
                                        sx={{

                                        }}
                                    />
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorElSort}
                                    open={openSort}
                                    onClose={handleCloseSort}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                    sx={{
                                        '& .MuiMenu-paper': {
                                            borderRadius: "10px",
                                            border: "solid 1px #106EED"
                                        }
                                    }}
                                >
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="CreatedUp" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'CreatedUp'} />} label="Created" />
                                        <NorthOutlinedIcon sx={{
                                            fontSize: "1.1rem",
                                            color: "#2A589C"
                                        }} />
                                    </MenuItem>
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="CreatedDown" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'CreatedDown'} />} label="Created" />
                                        <SouthOutlinedIcon sx={{
                                            fontSize: "1.1rem",
                                            color: "#2A589C"
                                        }} />
                                    </MenuItem>
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="name-a-z" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'name-a-z'} />} label="Name A-Z" />
                                    </MenuItem>
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="name-z-a" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'name-z-a'} />} label="Name Z-A" />
                                    </MenuItem>
                                </Menu>
                            </Box>
                            <Box
                                sx={{
                                    [theme.breakpoints.down('sm')]: {
                                        width: "50%"
                                    }
                                }}
                            >
                                <Button
                                    id="basic-button"
                                    aria-controls={openFilter ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openFilter ? 'true' : undefined}
                                    onClick={handleClickFilter}
                                    sx={{
                                        background: "#fff",
                                        fontSize: "0.9rem",
                                        color: "lightSecondary.main",
                                        textTransform: "inherit",
                                        fontWeight: "600",
                                        p: "10px 20px",
                                        '&:hover': {
                                            background: "#fff",
                                        },
                                        [theme.breakpoints.down('sm')]: {
                                            width: "100%"
                                        }
                                    }}
                                >
                                    Filter
                                    <KeyboardArrowDownOutlined
                                    />
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorElFilter}
                                    open={openFilter}
                                    onClose={handleCloseFilter}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                    sx={{
                                        '& .MuiMenu-paper': {
                                            borderRadius: "10px",
                                            border: "solid 1px #106EED",
                                            minWidth: "280px",
                                            px: 2.3,
                                            py: 1
                                        }
                                    }}
                                >
                                    <Box sx={{
                                        mb: 1.5
                                    }}>
                                        <Typography
                                            sx={{
                                                fontSize: "12px",
                                                fontWeight: '500',
                                                color: 'ltheme.main',
                                                lineHeight: '24px',
                                            }}
                                            variant="body2">
                                            Select Industry
                                        </Typography>
                                        <FormControl fullWidth
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none'
                                                }
                                            }}
                                        >
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={designation}
                                                onChange={handleChange}
                                                displayEmpty
                                                IconComponent={KeyboardArrowDownOutlinedIcon}
                                                sx={{
                                                    background: "#ECF6FF",
                                                    '& .MuiSelect-select': {
                                                        minHeight: "20px",
                                                        padding: "11px 14px",
                                                        color: "lightSecondary.main",
                                                        fontWeight: "600",
                                                        fontSize: "0.9rem"
                                                    },
                                                    '& .MuiSelect-icon': {
                                                        color: 'lightSecondary.main'
                                                    },
                                                }}
                                            >
                                                <MenuItem>Select Industry</MenuItem>
                                                <MenuItem value={2}>Insurance</MenuItem>
                                                <MenuItem value={3}>Citizen service</MenuItem>
                                                <MenuItem value={4}>Healthcare</MenuItem>
                                                <MenuItem value={5}>Supply chain</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontSize: "12px",
                                                fontWeight: '500',
                                                color: 'ltheme.main',
                                                lineHeight: '24px',
                                            }}
                                            variant="body2">
                                            Select Type
                                        </Typography>
                                        <FormControl fullWidth
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none'
                                                }
                                            }}
                                        >
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={designation}
                                                onChange={handleChange}
                                                displayEmpty
                                                IconComponent={KeyboardArrowDownOutlinedIcon}
                                                sx={{
                                                    background: "#ECF6FF",
                                                    '& .MuiSelect-select': {
                                                        minHeight: "20px",
                                                        padding: "11px 14px",
                                                        color: "lightSecondary.main",
                                                        fontWeight: "600",
                                                        fontSize: "0.9rem"
                                                    },
                                                    '& .MuiSelect-icon': {
                                                        color: 'lightSecondary.main'
                                                    },
                                                }}
                                            >
                                                <MenuItem>Select Type</MenuItem>
                                                <MenuItem value={12}>All</MenuItem>
                                                <MenuItem value={13}>Starred</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box sx={{
                                        display: 'flex',
                                        gap: 2,
                                        mt: 2
                                    }}>
                                        <Box sx={{
                                            width: '50%'
                                        }}>
                                            <Button variant="outlined"
                                                sx={{
                                                    width: "100%",
                                                    textTransform: 'inherit',
                                                    p: "7px 15px"
                                                }}
                                            >
                                                Clear
                                            </Button>
                                        </Box>
                                        <Box sx={{
                                            width: '50%'
                                        }}>
                                            <Button variant="contained"
                                                sx={{
                                                    width: "100%",
                                                    textTransform: 'inherit',
                                                    p: "7px 15px",
                                                    boxShadow: 'none'
                                                }}>Apply
                                            </Button>
                                        </Box>
                                    </Box>
                                </Menu>
                            </Box>
                        </Stack>
                        <List
                            sx={{
                                p: "0",
                                '& .MuiListItem-root + .MuiListItem-root': {
                                    mt: 1.3
                                }
                            }}
                        >
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={() => handleCommitment('invested')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('1.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Del Phineum
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (COO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >AsianWeb Technologies</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >9 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Invested
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $50k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={() => handleCommitment('invested')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('2.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Percy Kewshun
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (CTO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >WeDigTech</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >12 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Invested
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $20k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={() => handleCommitment('invested')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('3.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">David Jordan
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (CEO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >Bitcoin</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >18 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Invested
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $150k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={() => handleCommitment('invested')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('4.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Kydae Daniels
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (COO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >Verse Techno</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >23 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Invested
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $80k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={() => handleCommitment('invested')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('avatar-1.png')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Tbone Jod
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (CTO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >Four Screens</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >27 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Invested
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $500k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                        </List>
                        <Stack
                            direction="row"
                            sx={{
                                justifyContent: 'center',
                                my: 2.5
                            }}
                        >
                            <Pagination count={3} page={page} onChange={handlePaginationChange}
                                sx={{
                                    '& .MuiButtonBase-root': {
                                        color: 'secondary.main',
                                        fontSize: '1.2rem',
                                        fontWeight: '700',
                                        minWidth: '45px',
                                        height: '45px',
                                        '&.Mui-selected': {
                                            backgroundColor: 'secondary.main',
                                            color: '#fff',
                                            borderRadius: '6px'
                                        },
                                        [theme.breakpoints.down('md')]: {
                                            fontSize: '1rem',
                                            minWidth: '30px',
                                            height: '30px',
                                        }
                                    }
                                }}
                                renderItem={(item) => (
                                    <PaginationItem
                                        slots={{ previous: KeyboardDoubleArrowLeftOutlinedIcon, next: KeyboardDoubleArrowRightOutlinedIcon }}
                                        {...item}
                                    />
                                )}

                            />
                        </Stack>
                    </MainCard>
                </Grid>
                <Grid item xs={12} md={6} lg={6} 
                    sx={{
                        mb:2
                    }}
                >
                    <MainCard content={false}
                        sx={{
                            backgroundColor: "#ECF6FF",
                            border: "none",
                            padding: "20px",
                            boxShadow: "none",
                            borderRadius: "10px"
                        }}
                    >

                        <Typography variant='h6'
                            sx={{
                                color: 'secondary.main',
                                fontSize: "1.1rem",
                                fontWeight: "700",
                                mb: 1
                            }}
                        >
                            Commitments
                        </Typography>
                        <Stack
                            direction="row"
                            sx={{
                                justifyItems: 'center',
                                justifyContent: 'space-between',
                                mt: 0,
                                [theme.breakpoints.down('md')]: {
                                    flexWrap: 'wrap'
                                }
                            }}
                        >
                            <Search
                                sx={{
                                    width: 'calc(100% - 150px)',
                                    backgroundColor: '#DBEBF8',
                                    mb: 2.5,
                                    mr: 2,
                                    [theme.breakpoints.down('md')]: {
                                        width: 'calc(100% - 220px)',
                                    },
                                    [theme.breakpoints.down('sm')]: {
                                        mr: 0,
                                        width: '100%',
                                    }
                                }}
                            >
                                <SearchIconWrapper>
                                    <SearchIcon sx={{ color: "lightSecondary.main" }} />
                                </SearchIconWrapper>
                                <StyledInputBase
                                    id="searchBox"
                                    placeholder="Search commitements"
                                    inputProps={{ 'aria-label': 'search' }}
                                />
                            </Search>
                            <Box
                                sx={{
                                    mr: 2,
                                    mb: 2.5,
                                    [theme.breakpoints.down('sm')]: {
                                        width: "calc(50% - 0.5rem)",
                                        mr: '0.5rem',
                                    }
                                }}
                            >
                                <Button
                                    id="basic-button"
                                    aria-controls={openSort ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openSort ? 'true' : undefined}
                                    onClick={handleClickSort}
                                    sx={{
                                        background: "#fff",
                                        fontSize: "0.9rem",
                                        color: "lightSecondary.main",
                                        textTransform: "inherit",
                                        fontWeight: "600",
                                        p: "10px 20px",
                                        '&:hover': {
                                            background: "#fff",
                                        },
                                        [theme.breakpoints.down('md')]: {
                                            width: "100%"
                                        }
                                    }}
                                >
                                    Sort
                                    <KeyboardArrowDownOutlined
                                        sx={{

                                        }}
                                    />
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorElSort}
                                    open={openSort}
                                    onClose={handleCloseSort}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                    sx={{
                                        '& .MuiMenu-paper': {
                                            borderRadius: "10px",
                                            border: "solid 1px #106EED"
                                        }
                                    }}
                                >
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="CreatedUp" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'CreatedUp'} />} label="Created" />
                                        <NorthOutlinedIcon sx={{
                                            fontSize: "1.1rem",
                                            color: "#2A589C"
                                        }} />
                                    </MenuItem>
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="CreatedDown" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'CreatedDown'} />} label="Created" />
                                        <SouthOutlinedIcon sx={{
                                            fontSize: "1.1rem",
                                            color: "#2A589C"
                                        }} />
                                    </MenuItem>
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="name-a-z" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'name-a-z'} />} label="Name A-Z" />
                                    </MenuItem>
                                    <MenuItem
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: "0.9rem",
                                                color: "#2A589C",
                                                fontWeight: "600",
                                            }
                                        }}
                                        onClick={handleCloseSort}>
                                        <FormControlLabel
                                            value="name-z-a" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'name-z-a'} />} label="Name Z-A" />
                                    </MenuItem>
                                </Menu>
                            </Box>
                            <Box
                                sx={{
                                    [theme.breakpoints.down('sm')]: {
                                        width: "50%"
                                    }
                                }}
                            >
                                <Button
                                    id="basic-button"
                                    aria-controls={openFilter ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openFilter ? 'true' : undefined}
                                    onClick={handleClickFilter}
                                    sx={{
                                        background: "#fff",
                                        fontSize: "0.9rem",
                                        color: "lightSecondary.main",
                                        textTransform: "inherit",
                                        fontWeight: "600",
                                        p: "10px 20px",
                                        '&:hover': {
                                            background: "#fff",
                                        },
                                        [theme.breakpoints.down('sm')]: {
                                            width: "100%"
                                        }
                                    }}
                                >
                                    Filter
                                    <KeyboardArrowDownOutlined
                                    />
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorElFilter}
                                    open={openFilter}
                                    onClose={handleCloseFilter}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                    sx={{
                                        '& .MuiMenu-paper': {
                                            borderRadius: "10px",
                                            border: "solid 1px #106EED",
                                            minWidth: "280px",
                                            px: 2.3,
                                            py: 1
                                        }
                                    }}
                                >
                                    <Box sx={{
                                        mb: 1.5
                                    }}>
                                        <Typography
                                            sx={{
                                                fontSize: "12px",
                                                fontWeight: '500',
                                                color: 'ltheme.main',
                                                lineHeight: '24px',
                                            }}
                                            variant="body2">
                                            Select Industry
                                        </Typography>
                                        <FormControl fullWidth
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none'
                                                }
                                            }}
                                        >
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={designation}
                                                onChange={handleChange}
                                                displayEmpty
                                                IconComponent={KeyboardArrowDownOutlinedIcon}
                                                sx={{
                                                    background: "#ECF6FF",
                                                    '& .MuiSelect-select': {
                                                        minHeight: "20px",
                                                        padding: "11px 14px",
                                                        color: "lightSecondary.main",
                                                        fontWeight: "600",
                                                        fontSize: "0.9rem"
                                                    },
                                                    '& .MuiSelect-icon': {
                                                        color: 'lightSecondary.main'
                                                    },
                                                }}
                                            >
                                                <MenuItem>Select Industry</MenuItem>
                                                <MenuItem value={2}>Insurance</MenuItem>
                                                <MenuItem value={3}>Citizen service</MenuItem>
                                                <MenuItem value={4}>Healthcare</MenuItem>
                                                <MenuItem value={5}>Supply chain</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontSize: "12px",
                                                fontWeight: '500',
                                                color: 'ltheme.main',
                                                lineHeight: '24px',
                                            }}
                                            variant="body2">
                                            Select Type
                                        </Typography>
                                        <FormControl fullWidth
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none'
                                                }
                                            }}
                                        >
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={designation}
                                                onChange={handleChange}
                                                displayEmpty
                                                IconComponent={KeyboardArrowDownOutlinedIcon}
                                                sx={{
                                                    background: "#ECF6FF",
                                                    '& .MuiSelect-select': {
                                                        minHeight: "20px",
                                                        padding: "11px 14px",
                                                        color: "lightSecondary.main",
                                                        fontWeight: "600",
                                                        fontSize: "0.9rem"
                                                    },
                                                    '& .MuiSelect-icon': {
                                                        color: 'lightSecondary.main'
                                                    },
                                                }}
                                            >
                                                <MenuItem>Select Type</MenuItem>
                                                <MenuItem value={12}>All</MenuItem>
                                                <MenuItem value={13}>Starred</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box sx={{
                                        display: 'flex',
                                        gap: 2,
                                        mt: 2
                                    }}>
                                        <Box sx={{
                                            width: '50%'
                                        }}>
                                            <Button variant="outlined"
                                                sx={{
                                                    width: "100%",
                                                    textTransform: 'inherit',
                                                    p: "7px 15px"
                                                }}
                                            >
                                                Clear
                                            </Button>
                                        </Box>
                                        <Box sx={{
                                            width: '50%'
                                        }}>
                                            <Button variant="contained"
                                                sx={{
                                                    width: "100%",
                                                    textTransform: 'inherit',
                                                    p: "7px 15px",
                                                    boxShadow: 'none'
                                                }}>Apply
                                            </Button>
                                        </Box>
                                    </Box>
                                </Menu>
                            </Box>
                        </Stack>
                        <List
                            sx={{
                                p: "0",
                                '& .MuiListItem-root + .MuiListItem-root': {
                                    mt: 1.3
                                }
                            }}
                        >
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={()=>handleCommitment('committed')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('1.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Nats White
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (COO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >AsianWeb Technologies</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >12 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Committed
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $150k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={()=>handleCommitment('committed')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('2.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">chel Santner
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (CTO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >WeDigTech</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >12 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Committed
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $20k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={()=>handleCommitment('committed')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('3.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Betty Carne
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (CEO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >Bitcoin</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >18 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Committed
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $150k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={()=>handleCommitment('committed')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('4.jpg')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Tenz Jordan
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (COO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >Verse Techno</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >23 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Committed
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $80k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem
                                sx={{
                                    p: 0,
                                }}
                            >
                                <ListItemButton
                                    onClick={()=>handleCommitment('committed')}
                                    sx={{
                                        padding: '10px 24px',
                                        borderRadius: '10px',
                                        background: '#fff'
                                    }}
                                >
                                    <ListItemAvatar
                                        sx={{
                                            width: "72px"
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                color: 'success.main',
                                                bgcolor: 'success.lighter',
                                                width: '72px',
                                                height: '72px'
                                            }}
                                            src={getImages('avatar-1.png')}
                                        >

                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        sx={{
                                            pl: '20px',
                                            width: "60%"
                                        }}>
                                        <Typography noWrap
                                            sx={{
                                                fontSize: "1.2rem",
                                                fontWeight: '700',
                                                color: 'secondary.main',
                                                lineHeight: '22px',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                            variant="h6">Cindy Mellow
                                            <span style={{
                                                color: "#A2C2F1",
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                paddingLeft: '5px'
                                            }}>
                                                (CTO)
                                            </span>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                color: 'lightSecondary.main',
                                                maxWidth: '220px',
                                                mb: 0.5,
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >Four Screens</Typography>
                                        <Typography
                                            noWrap
                                            variant="body2"
                                            sx={{
                                                color: "ltheme.main",
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                maxWidth: '220px',
                                                [theme.breakpoints.down('sm')]: {
                                                    maxWidth: '110px'
                                                }
                                            }}
                                        >27 Feb 2023</Typography>
                                    </ListItemText>
                                    <ListItemText
                                        sx={{
                                            width: "calc(40% - 56px)"
                                        }}
                                    >
                                        <Stack alignItems="flex-end">
                                            <Typography
                                                variant="body2" noWrap
                                                sx={{
                                                    color: "ltheme.main",
                                                    fontSize: '0.9rem',
                                                    fontWeight: '500',
                                                    maxWidth: '220px',
                                                    [theme.breakpoints.down('sm')]: {
                                                        maxWidth: '110px'
                                                    }
                                                }}
                                            >
                                                Committed
                                            </Typography>
                                            <Box component="span"
                                                sx={{
                                                    fontSize: "1.4rem",
                                                    fontWeight: '700',
                                                    color: 'lightSecondary.main',
                                                    lineHeight: '1.6rem',
                                                }}>
                                                $500k
                                            </Box>
                                        </Stack>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                        </List>
                        <Stack
                            direction="row"
                            sx={{
                                justifyContent: 'center',
                                my: 2.5
                            }}
                        >
                            <Pagination count={3} page={page} onChange={handlePaginationChange}
                                sx={{
                                    '& .MuiButtonBase-root': {
                                        color: 'secondary.main',
                                        fontSize: '1.2rem',
                                        fontWeight: '700',
                                        minWidth: '45px',
                                        height: '45px',
                                        '&.Mui-selected': {
                                            backgroundColor: 'secondary.main',
                                            color: '#fff',
                                            borderRadius: '6px'
                                        },
                                        [theme.breakpoints.down('md')]: {
                                            fontSize: '1rem',
                                            minWidth: '30px',
                                            height: '30px',
                                        }
                                    }
                                }}
                                renderItem={(item) => (
                                    <PaginationItem
                                        slots={{ previous: KeyboardDoubleArrowLeftOutlinedIcon, next: KeyboardDoubleArrowRightOutlinedIcon }}
                                        {...item}
                                    />
                                )}

                            />
                        </Stack>
                    </MainCard>
                </Grid>
            </Grid>
            {/* Commitment dialog */}
            <Modals open={openCommitment} modalWidth={600} handleClose={closeCommitment} >
                <InvestmentsProcessModal handleClose={closeCommitment} investTypeName={investTypeName} />
            </Modals>
        </>
    )
}

export default SolutionInvestmentSummary